<template>
    <transition name="modal" enter-active-class="animated fadeIn" appear>
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <h4 class="text-dark">کارهای جاری کاربر:</h4>
                    </div>
                    <div class="modal-body m-0">
                        <div class="modal-list-group">                           
                            <div class="list-group list-custom-small list-icon-0">
                                <a href="#" v-for="task in activityList" :key="task.taskFolderId">
                                    <div>
                                        <i class="fa fa-hashtag color-blue2-dark"></i>
                                        <span class="text-muted">{{task.taskFolderNo}}</span>

                                    </div>

                                    <div>
                                        <i class="fa fa-check color-red1-dark"></i>
                                        <span class="font-weight-bold">{{task.title}}</span>
                                    </div>
                                    <div>
                                        <i class="fa fa-user-check color-green2-light"></i>
                                        <span class="text-muted">ارجاع دهنده: <b>{{task.referrerUserTitle}}</b></span>

                                    </div>
                                    <div>
                                        <i class="fa fa-star color-yellow2-light"></i>
                                        <span class="text-muted">اولویت: <b>{{task.priorityTitle}}</b></span>

                                    </div>
                                    <div>
                                        <i class="fa fa-calendar-check color-magenta2-light"></i>
                                        <span class="text-muted">زمان شروع: <b class="d-inline-block ltr">{{task.startDateTime}}</b></span>
                                    </div>
                                    <div>
                                        <i class="fa fa-calendar-times color-red2-light"></i>
                                        <span class="text-muted">زمان پایان: <b class="d-inline-block ltr">{{task.endDateTime}}</b></span>
                                    </div>

                                        <div>
                                            <i class="fa fa-exclamation color-orange-light"></i>
                                            <span class="text-muted">مانده به اتمام:</span>
                                            <b class="text-muted ltr d-inline-block">{{task.strDayHourMin}}</b>
                                        </div>

                                </a>


                                <div v-if="Loading" class="d-flex justify-content-center w-100 py-5">
                                    <div class="spinner-border color-magenta2-dark" role="status"></div>
                                </div>

                                <div v-if="activityList.length==0 && Loading==false">
                                    <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                                    <p class="text-center py-3">{{lableText('TaskName')??'وظیفه'}} ای یافت نشد.</p>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="modal-footer py-1 px-2">
                        <slot name="footer">

                            <button class="btn btn-xxs rounded-s bg-red1-light" @click="$emit('close')">
                                <i class="fa fa-times ml-2"></i>
                                بستن
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>



</template>
<script>


    export default {
        props: ['userId'],
        data() {
            return {
               activityList:[],
                Loading: false,
               
            };
        },
       
        mounted() {
            this.getActivityList();
        },
        methods: {
            getActivityList() {
                this.$http.get("Task/GetActivityAnalysisForNewTask?userId=" + this.userId)
                    .then(data => {
                        this.activityList = data.data;
                    });
            },
            openDetails(taskFolderId, taskId) {
                this.$router.push({ name: 'EditTask', params: { taskFolderId: taskFolderId, taskId: taskId } });
                document.getElementsByClassName('menu-hider')[0].click();
            }
        }

    };
</script>
<style>
       .modal-mask {
           position: fixed;
           z-index: 1;
           top: 0;
           left: 0;
           width: 100%;
           height: 100%;
           background-color: rgba(0, 0, 0, 0.5);
           display: table;
           transition: opacity 0.3s ease;
       }

       .modal-wrapper {
           display: table-cell;
           vertical-align: middle;
       }

       .modal-container {
           width: 300px;
           margin: 0px auto;
           background-color: #fff;
           border-radius: 2px;
           box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
           transition: all 0.3s ease;
       }

       .modal-header h3 {
           margin-top: 0;
           color: #42b983;
       }

       .modal-body {
           margin: 20px 0;
           line-height: 1;
       }

       .modal-default-button {
           float: right;
       }


       .modal-enter {
           opacity: 0;
       }

       .modal-leave-active {
           opacity: 0;
       }

           .modal-enter .modal-container,
           .modal-leave-active .modal-container {
               -webkit-transform: scale(2);
               transform: scale(2);
           }
</style>
